<section class="edit-page">

  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="showLoader">
    <mat-spinner diameter="48"></mat-spinner>
    <p class="loading-text">Processing...</p>
  </div>

  <!-- Top Navigation -->
  <div class="edit-nav">
    <button class="back-link" (click)="goBack()">
      <i class="material-icons">arrow_back</i>
      <span>Back</span>
    </button>
    <h1 class="page-heading">Edit Material</h1>
    <div class="nav-spacer"></div>
  </div>

  <!-- Form Content -->
  <div class="edit-content" *ngIf="updatedMaterialInfo">
    <form id="myForm" class="edit-form">

      <!-- Section: Basic Info -->
      <div class="form-section">
        <div class="section-header">
          <i class="material-icons section-icon">info</i>
          <h3 class="section-title">Basic Information</h3>
        </div>

        <div class="section-body">
          <div class="field-group">
            <mat-form-field class="full-width plain-field" appearance="outline">
              <mat-label>Title</mat-label>
              <input matInput type="text" id="titleInput" name="title"
                [(ngModel)]="updatedMaterialInfo.title"
                (keyup)="checkFormValidation()"
                (focus)="checkFormValidation()"
                required />
              <mat-error *ngIf="!updatedMaterialInfo.title">Please enter a title.</mat-error>
            </mat-form-field>
          </div>

          <div class="field-group">
            <mat-form-field class="full-width plain-field" appearance="outline">
              <mat-label>Description</mat-label>
              <textarea matInput type="text" id="edit_description_area"
                class="description-textarea"
                name="description"
                [(ngModel)]="updatedMaterialInfo.description"
                (keyup)="checkFormValidation()"
                (keydown)="onDescriptionKeydown($event)"
                (focus)="checkFormValidation()"
                placeholder="Describe your material and how it can be helpful to another educator."
                rows="4"
                required>
              </textarea>
              <mat-error *ngIf="!updatedMaterialInfo.description">Please enter a description.</mat-error>
            </mat-form-field>

            <div class="word-count-row">
              <span class="word-count-label">Words: <strong>{{ currentWordCount }}</strong></span>
              <span class="word-count-label">Remaining: <strong>{{ wordsLeft }}</strong></span>
            </div>
          </div>
        </div>
      </div>

      <!-- Section: Categories -->
      <div class="form-section">
        <div class="section-header">
          <i class="material-icons section-icon">folder_open</i>
          <h3 class="section-title">Categories</h3>
          <button type="button" class="add-category-btn" (click)="addCategory()">
            <i class="material-icons">add</i>
            Add Category
          </button>
        </div>

        <div class="section-body">
          <div *ngFor="let _category of currentCategories; let i=index" class="category-row">
            <div class="category-fields">
              <mat-form-field class="cat-field plain-field" appearance="outline">
                <mat-label>Category</mat-label>
                <mat-select name="category-{{i}}" (selectionChange)="checkForSubs($event.value, i)" [(ngModel)]="_category.category" required [compareWith]="dropdownNameCompareFn">
                  <mat-option>None</mat-option>
                  <mat-option *ngFor="let category of materialCategories" [value]="category">
                    {{ category?.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field *ngIf="_category?.availableSubCategories?.length" class="cat-field plain-field" appearance="outline">
                <mat-label>Sub-Category</mat-label>
                <mat-select name="subCategorySelect-{{i}}" (selectionChange)="subCatChanged($event.value, i)" required [(ngModel)]="_category.subCategory">
                  <mat-option>None</mat-option>
                  <mat-option *ngFor="let _subCategory of _category.availableSubCategories" [value]="_subCategory?.name">
                    {{ _subCategory?.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <button type="button" class="remove-cat-btn" (click)="removeGroup(_category)">
              <i class="material-icons">close</i>
            </button>
          </div>

          <div class="category-errors" *ngIf="hasError?.messages?.length">
            <div class="error-msg" *ngFor="let _message of hasError.messages">
              <i class="material-icons">warning</i>
              {{ _message }}
            </div>
          </div>

          <div class="empty-categories" *ngIf="!currentCategories?.length">
            <p>No categories added yet. Click "Add Category" to get started.</p>
          </div>
        </div>
      </div>

      <!-- Section: Current Material Preview -->
      <div class="form-section">
        <div class="section-header">
          <i class="material-icons section-icon">image</i>
          <h3 class="section-title">Current File Preview</h3>
        </div>

        <div class="section-body">
          <div class="preview-grid">
            <div class="main-preview" *ngIf="currentlySavedImage">
              <img id="current-image" [src]="currentlySavedImage" alt="Current material image" />
            </div>

            <div *ngIf="materialBeingUpdated?.fileImageArray?.length > 0" class="thumb-preview-strip">
              <div *ngFor="let _smallImage of materialBeingUpdated?.fileImageArray"
                class="thumb-preview-item"
                [class.selected]="currentlySavedImage && _smallImage === currentlySavedImage"
                (click)="currentPreviewImageSelected(_smallImage)">
                <img [src]="_smallImage" alt="thumbnail" />
              </div>
            </div>
          </div>

          <button type="button" class="toggle-content-btn" (click)="toggleChangeContent()">
            <i class="material-icons">{{ changeContent ? 'undo' : 'swap_horiz' }}</i>
            {{ changeContent ? 'Keep Current File' : 'Change File Content' }}
          </button>
        </div>
      </div>

      <!-- Section: Upload New Content (conditional) -->
      <div class="form-section upload-section" *ngIf="changeContent">
        <div class="section-header">
          <i class="material-icons section-icon">cloud_upload</i>
          <h3 class="section-title">Upload New Content</h3>
        </div>

        <div class="section-body">
          <div class="upload-row">
            <!-- Drag & Drop -->
            <div class="drop-zone" [class.valid]="tempMainFileName" [class.invalid]="!tempMainFileName">
              <input #file id="fileInput" type="file" name="myfile" class="file-input"
                accept="image/jpeg, image/jpg, image/gif, image/png, application/pdf, video/mp4, video/x-m4v, video/*"
                (change)="onFilesAdded($event)" />
              <div class="drop-zone-content">
                <i class="material-icons drop-icon">{{ tempMainFileName ? 'check_circle' : 'cloud_upload' }}</i>
                <p class="drop-title">{{ tempMainFileName ? tempMainFileName : 'Drag & drop your file here' }}</p>
                <p class="drop-hint" *ngIf="!tempMainFileName">or click to browse (image, PDF, or video)</p>
              </div>
            </div>

            <!-- File Preview -->
            <div class="new-file-preview" *ngIf="fileToPreview">
              <video *ngIf="updatedMaterialInfo?.fileType === 'Video'" class="preview-video" [src]="fileToPreview" controls></video>
              <img *ngIf="updatedMaterialInfo?.fileType !== 'Video'" class="preview-image" [src]="fileToPreview" alt="Preview" />
            </div>
          </div>

          <!-- Thumbnail Options -->
          <div class="thumbnail-options">
            <mat-radio-group class="thumb-radio-group" [ngModelOptions]="{standalone: true}" [(ngModel)]="uploadValue" (change)="checkUploadThumbnailValue()">
              <mat-radio-button class="thumb-radio" value="'1'">Auto-generated thumbnails</mat-radio-button>

              <div class="thumbnail-grid" [class.valid]="updatedMaterialInfo?.defaultImage" [class.invalid]="!updatedMaterialInfo?.defaultImage">
                <div *ngIf="!fileToPreview && uploadValue === '1' && coverImages.length <= 0" class="thumbnail-placeholder">
                  <i class="material-icons">photo_library</i>
                  <p>Thumbnails will generate once you upload your file.</p>
                </div>

                <div *ngIf="uploadValue === '2' && ['PDF','Video'].includes(updatedMaterialInfo?.fileType) && coverImages.length <= 0" class="thumbnail-placeholder">
                  <i class="material-icons">add_photo_alternate</i>
                  <p>Upload image file(s) for the cover image.</p>
                </div>

                <div *ngIf="coverImages?.length > 0" class="cover-image-list">
                  <div class="cover-image-item" *ngFor="let _img of coverImages" [class.selected]="_img === fileToPreview" (click)="imageSelected(_img)">
                    <img [src]="_img" alt="Thumbnail" />
                  </div>
                </div>
              </div>

              <mat-radio-button *ngIf="['PDF','Video'].includes(updatedMaterialInfo?.fileType)" class="thumb-radio upload-own-radio" value="2">Upload custom thumbnails</mat-radio-button>

              <div *ngIf="uploadValue === '2'" class="custom-upload-input">
                <input type="file" #ownCoverImage id="ownCoverImage" name="ownCoverImage" accept="image/jpeg, image/gif, image/png" (change)="onOwnCoverImageUpload($event)" multiple />
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="form-actions">
        <button type="button" class="cancel-btn" (click)="goBack()">Cancel</button>
        <button type="button" class="save-btn" [disabled]="!validForm" (click)="updateMaterial()">
          <i class="material-icons">save</i>
          Update Material
        </button>
      </div>
    </form>
  </div>
</section>
